import "./common-utils-DjDyp7mO.mjs";
import "react/jsx-runtime";
import "./client-DHHkGJP0.mjs";
import "react";
import "./js.cookie-Cz6eSHLt.mjs";
const l = (n) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(n), c = (n) => {
  let t = "";
  const r = n.toString();
  return r && (t = r.replace(/\D+/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")), t;
}, a = (n, t, r) => {
  if (n.length) {
    for (const e of n) {
      if (e.HstMenuItemRepresentation.url.includes(t) && e.HstMenuItemRepresentation.url.length - t.length === e.HstMenuItemRepresentation.url.indexOf(t))
        return {
          currentPage: e.HstMenuItemRepresentation.name,
          currentPageUrl: e.HstMenuItemRepresentation.url,
          currentPageParams: e.HstMenuItemRepresentation.parameters,
          breadCrumbs: r
        };
      if (e.HstMenuItemRepresentation.menuItems.length) {
        r.push({
          pageName: e.HstMenuItemRepresentation.name,
          pageURL: e.HstMenuItemRepresentation.url,
          pageParameters: e.HstMenuItemRepresentation.parameters
        });
        const s = a(
          e.HstMenuItemRepresentation.menuItems,
          t,
          r
        );
        if (s) return s;
      }
    }
    r.pop();
  }
}, I = (n) => {
  if (n.length) {
    const t = window.location.pathname;
    return a(n, t, []);
  }
};
export {
  c as f,
  I as g,
  l as i
};
//# sourceMappingURL=utils-X2ED81Se.mjs.map
